var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
let CountriesService = (_dec = computed('i18n'), _dec2 = computed('i18n'), _class = class CountriesService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
  }
  get countryNamesByCode() {
    return {
      AD: this.i18n.t('countriesByCode.AD'),
      AE: this.i18n.t('countriesByCode.AE'),
      AF: this.i18n.t('countriesByCode.AF'),
      AG: this.i18n.t('countriesByCode.AG'),
      AI: this.i18n.t('countriesByCode.AI'),
      AL: this.i18n.t('countriesByCode.AL'),
      AM: this.i18n.t('countriesByCode.AM'),
      AO: this.i18n.t('countriesByCode.AO'),
      AQ: this.i18n.t('countriesByCode.AQ'),
      AR: this.i18n.t('countriesByCode.AR'),
      AS: this.i18n.t('countriesByCode.AS'),
      AT: this.i18n.t('countriesByCode.AT'),
      AU: this.i18n.t('countriesByCode.AU'),
      AW: this.i18n.t('countriesByCode.AW'),
      AX: this.i18n.t('countriesByCode.AX'),
      AZ: this.i18n.t('countriesByCode.AZ'),
      BA: this.i18n.t('countriesByCode.BA'),
      BB: this.i18n.t('countriesByCode.BB'),
      BD: this.i18n.t('countriesByCode.BD'),
      BE: this.i18n.t('countriesByCode.BE'),
      BF: this.i18n.t('countriesByCode.BF'),
      BG: this.i18n.t('countriesByCode.BG'),
      BH: this.i18n.t('countriesByCode.BH'),
      BI: this.i18n.t('countriesByCode.BI'),
      BJ: this.i18n.t('countriesByCode.BJ'),
      BL: this.i18n.t('countriesByCode.BL'),
      BM: this.i18n.t('countriesByCode.BM'),
      BN: this.i18n.t('countriesByCode.BN'),
      BO: this.i18n.t('countriesByCode.BO'),
      BQ: this.i18n.t('countriesByCode.BQ'),
      BR: this.i18n.t('countriesByCode.BR'),
      BS: this.i18n.t('countriesByCode.BS'),
      BT: this.i18n.t('countriesByCode.BT'),
      BV: this.i18n.t('countriesByCode.BV'),
      BW: this.i18n.t('countriesByCode.BW'),
      BY: this.i18n.t('countriesByCode.BY'),
      BZ: this.i18n.t('countriesByCode.BZ'),
      CA: this.i18n.t('countriesByCode.CA'),
      CC: this.i18n.t('countriesByCode.CC'),
      CD: this.i18n.t('countriesByCode.CD'),
      CF: this.i18n.t('countriesByCode.CF'),
      CG: this.i18n.t('countriesByCode.CG'),
      CH: this.i18n.t('countriesByCode.CH'),
      CI: this.i18n.t('countriesByCode.CI'),
      CK: this.i18n.t('countriesByCode.CK'),
      CL: this.i18n.t('countriesByCode.CL'),
      CM: this.i18n.t('countriesByCode.CM'),
      CN: this.i18n.t('countriesByCode.CN'),
      CO: this.i18n.t('countriesByCode.CO'),
      CR: this.i18n.t('countriesByCode.CR'),
      CU: this.i18n.t('countriesByCode.CU'),
      CV: this.i18n.t('countriesByCode.CV'),
      CW: this.i18n.t('countriesByCode.CW'),
      CX: this.i18n.t('countriesByCode.CX'),
      CY: this.i18n.t('countriesByCode.CY'),
      CZ: this.i18n.t('countriesByCode.CZ'),
      DE: this.i18n.t('countriesByCode.DE'),
      DJ: this.i18n.t('countriesByCode.DJ'),
      DK: this.i18n.t('countriesByCode.DK'),
      DM: this.i18n.t('countriesByCode.DM'),
      DO: this.i18n.t('countriesByCode.DO'),
      DZ: this.i18n.t('countriesByCode.DZ'),
      EC: this.i18n.t('countriesByCode.EC'),
      EE: this.i18n.t('countriesByCode.EE'),
      EG: this.i18n.t('countriesByCode.EG'),
      EH: this.i18n.t('countriesByCode.EH'),
      ER: this.i18n.t('countriesByCode.ER'),
      ES: this.i18n.t('countriesByCode.ES'),
      ET: this.i18n.t('countriesByCode.ET'),
      FI: this.i18n.t('countriesByCode.FI'),
      FJ: this.i18n.t('countriesByCode.FJ'),
      FK: this.i18n.t('countriesByCode.FK'),
      FM: this.i18n.t('countriesByCode.FM'),
      FO: this.i18n.t('countriesByCode.FO'),
      FR: this.i18n.t('countriesByCode.FR'),
      GA: this.i18n.t('countriesByCode.GA'),
      GB: this.i18n.t('countriesByCode.GB'),
      GD: this.i18n.t('countriesByCode.GD'),
      GE: this.i18n.t('countriesByCode.GE'),
      GF: this.i18n.t('countriesByCode.GF'),
      GG: this.i18n.t('countriesByCode.GG'),
      GH: this.i18n.t('countriesByCode.GH'),
      GI: this.i18n.t('countriesByCode.GI'),
      GL: this.i18n.t('countriesByCode.GL'),
      GM: this.i18n.t('countriesByCode.GM'),
      GN: this.i18n.t('countriesByCode.GN'),
      GP: this.i18n.t('countriesByCode.GP'),
      GQ: this.i18n.t('countriesByCode.GQ'),
      GR: this.i18n.t('countriesByCode.GR'),
      GS: this.i18n.t('countriesByCode.GS'),
      GT: this.i18n.t('countriesByCode.GT'),
      GU: this.i18n.t('countriesByCode.GU'),
      GW: this.i18n.t('countriesByCode.GW'),
      GY: this.i18n.t('countriesByCode.GY'),
      HK: this.i18n.t('countriesByCode.HK'),
      HM: this.i18n.t('countriesByCode.HM'),
      HN: this.i18n.t('countriesByCode.HN'),
      HR: this.i18n.t('countriesByCode.HR'),
      HT: this.i18n.t('countriesByCode.HT'),
      HU: this.i18n.t('countriesByCode.HU'),
      ID: this.i18n.t('countriesByCode.ID'),
      IE: this.i18n.t('countriesByCode.IE'),
      IL: this.i18n.t('countriesByCode.IL'),
      IM: this.i18n.t('countriesByCode.IM'),
      IN: this.i18n.t('countriesByCode.IN'),
      IO: this.i18n.t('countriesByCode.IO'),
      IQ: this.i18n.t('countriesByCode.IQ'),
      IR: this.i18n.t('countriesByCode.IR'),
      IS: this.i18n.t('countriesByCode.IS'),
      IT: this.i18n.t('countriesByCode.IT'),
      JE: this.i18n.t('countriesByCode.JE'),
      JM: this.i18n.t('countriesByCode.JM'),
      JO: this.i18n.t('countriesByCode.JO'),
      JP: this.i18n.t('countriesByCode.JP'),
      KE: this.i18n.t('countriesByCode.KE'),
      KG: this.i18n.t('countriesByCode.KG'),
      KH: this.i18n.t('countriesByCode.KH'),
      KI: this.i18n.t('countriesByCode.KI'),
      KM: this.i18n.t('countriesByCode.KM'),
      KN: this.i18n.t('countriesByCode.KN'),
      KP: this.i18n.t('countriesByCode.KP'),
      KR: this.i18n.t('countriesByCode.KR'),
      KW: this.i18n.t('countriesByCode.KW'),
      KY: this.i18n.t('countriesByCode.KY'),
      KZ: this.i18n.t('countriesByCode.KZ'),
      LA: this.i18n.t('countriesByCode.LA'),
      LB: this.i18n.t('countriesByCode.LB'),
      LC: this.i18n.t('countriesByCode.LC'),
      LI: this.i18n.t('countriesByCode.LI'),
      LK: this.i18n.t('countriesByCode.LK'),
      LR: this.i18n.t('countriesByCode.LR'),
      LS: this.i18n.t('countriesByCode.LS'),
      LT: this.i18n.t('countriesByCode.LT'),
      LU: this.i18n.t('countriesByCode.LU'),
      LV: this.i18n.t('countriesByCode.LV'),
      LY: this.i18n.t('countriesByCode.LY'),
      MA: this.i18n.t('countriesByCode.MA'),
      MC: this.i18n.t('countriesByCode.MC'),
      MD: this.i18n.t('countriesByCode.MD'),
      ME: this.i18n.t('countriesByCode.ME'),
      MF: this.i18n.t('countriesByCode.MF'),
      MG: this.i18n.t('countriesByCode.MG'),
      MH: this.i18n.t('countriesByCode.MH'),
      MK: this.i18n.t('countriesByCode.MK'),
      ML: this.i18n.t('countriesByCode.ML'),
      MM: this.i18n.t('countriesByCode.MM'),
      MN: this.i18n.t('countriesByCode.MN'),
      MO: this.i18n.t('countriesByCode.MO'),
      MP: this.i18n.t('countriesByCode.MP'),
      MQ: this.i18n.t('countriesByCode.MQ'),
      MR: this.i18n.t('countriesByCode.MR'),
      MS: this.i18n.t('countriesByCode.MS'),
      MT: this.i18n.t('countriesByCode.MT'),
      MU: this.i18n.t('countriesByCode.MU'),
      MV: this.i18n.t('countriesByCode.MV'),
      MW: this.i18n.t('countriesByCode.MW'),
      MX: this.i18n.t('countriesByCode.MX'),
      MY: this.i18n.t('countriesByCode.MY'),
      MZ: this.i18n.t('countriesByCode.MZ'),
      NA: this.i18n.t('countriesByCode.NA'),
      NC: this.i18n.t('countriesByCode.NC'),
      NE: this.i18n.t('countriesByCode.NE'),
      NF: this.i18n.t('countriesByCode.NF'),
      NG: this.i18n.t('countriesByCode.NG'),
      NI: this.i18n.t('countriesByCode.NI'),
      NL: this.i18n.t('countriesByCode.NL'),
      NO: this.i18n.t('countriesByCode.NO'),
      NP: this.i18n.t('countriesByCode.NP'),
      NR: this.i18n.t('countriesByCode.NR'),
      NU: this.i18n.t('countriesByCode.NU'),
      NZ: this.i18n.t('countriesByCode.NZ'),
      OM: this.i18n.t('countriesByCode.OM'),
      PA: this.i18n.t('countriesByCode.PA'),
      PE: this.i18n.t('countriesByCode.PE'),
      PF: this.i18n.t('countriesByCode.PF'),
      PG: this.i18n.t('countriesByCode.PG'),
      PH: this.i18n.t('countriesByCode.PH'),
      PK: this.i18n.t('countriesByCode.PK'),
      PL: this.i18n.t('countriesByCode.PL'),
      PM: this.i18n.t('countriesByCode.PM'),
      PN: this.i18n.t('countriesByCode.PN'),
      PR: this.i18n.t('countriesByCode.PR'),
      PS: this.i18n.t('countriesByCode.PS'),
      PT: this.i18n.t('countriesByCode.PT'),
      PW: this.i18n.t('countriesByCode.PW'),
      PY: this.i18n.t('countriesByCode.PY'),
      QA: this.i18n.t('countriesByCode.QA'),
      RE: this.i18n.t('countriesByCode.RE'),
      RO: this.i18n.t('countriesByCode.RO'),
      RS: this.i18n.t('countriesByCode.RS'),
      RU: this.i18n.t('countriesByCode.RU'),
      RW: this.i18n.t('countriesByCode.RW'),
      SA: this.i18n.t('countriesByCode.SA'),
      SB: this.i18n.t('countriesByCode.SB'),
      SC: this.i18n.t('countriesByCode.SC'),
      SD: this.i18n.t('countriesByCode.SD'),
      SE: this.i18n.t('countriesByCode.SE'),
      SG: this.i18n.t('countriesByCode.SG'),
      SH: this.i18n.t('countriesByCode.SH'),
      SI: this.i18n.t('countriesByCode.SI'),
      SJ: this.i18n.t('countriesByCode.SJ'),
      SK: this.i18n.t('countriesByCode.SK'),
      SL: this.i18n.t('countriesByCode.SL'),
      SM: this.i18n.t('countriesByCode.SM'),
      SN: this.i18n.t('countriesByCode.SN'),
      SO: this.i18n.t('countriesByCode.SO'),
      SR: this.i18n.t('countriesByCode.SR'),
      SS: this.i18n.t('countriesByCode.SS'),
      ST: this.i18n.t('countriesByCode.ST'),
      SV: this.i18n.t('countriesByCode.SV'),
      SX: this.i18n.t('countriesByCode.SX'),
      SY: this.i18n.t('countriesByCode.SY'),
      SZ: this.i18n.t('countriesByCode.SZ'),
      TC: this.i18n.t('countriesByCode.TC'),
      TD: this.i18n.t('countriesByCode.TD'),
      TF: this.i18n.t('countriesByCode.TF'),
      TG: this.i18n.t('countriesByCode.TG'),
      TH: this.i18n.t('countriesByCode.TH'),
      TJ: this.i18n.t('countriesByCode.TJ'),
      TK: this.i18n.t('countriesByCode.TK'),
      TL: this.i18n.t('countriesByCode.TL'),
      TM: this.i18n.t('countriesByCode.TM'),
      TN: this.i18n.t('countriesByCode.TN'),
      TO: this.i18n.t('countriesByCode.TO'),
      TR: this.i18n.t('countriesByCode.TR'),
      TT: this.i18n.t('countriesByCode.TT'),
      TV: this.i18n.t('countriesByCode.TV'),
      TW: this.i18n.t('countriesByCode.TW'),
      TZ: this.i18n.t('countriesByCode.TZ'),
      UA: this.i18n.t('countriesByCode.UA'),
      UG: this.i18n.t('countriesByCode.UG'),
      UM: this.i18n.t('countriesByCode.UM'),
      US: this.i18n.t('countriesByCode.US'),
      UY: this.i18n.t('countriesByCode.UY'),
      UZ: this.i18n.t('countriesByCode.UZ'),
      VA: this.i18n.t('countriesByCode.VA'),
      VC: this.i18n.t('countriesByCode.VC'),
      VE: this.i18n.t('countriesByCode.VE'),
      VG: this.i18n.t('countriesByCode.VG'),
      VI: this.i18n.t('countriesByCode.VI'),
      VN: this.i18n.t('countriesByCode.VN'),
      VU: this.i18n.t('countriesByCode.VU'),
      WF: this.i18n.t('countriesByCode.WF'),
      WS: this.i18n.t('countriesByCode.WS'),
      YE: this.i18n.t('countriesByCode.YE'),
      YT: this.i18n.t('countriesByCode.YT'),
      ZA: this.i18n.t('countriesByCode.ZA'),
      ZM: this.i18n.t('countriesByCode.ZM'),
      ZW: this.i18n.t('countriesByCode.ZW')
    };
  }
  get stateNamesByCode() {
    return {
      AU: {
        ACT: this.i18n.t('statesSelect.statesList.AU.ACT'),
        NSW: this.i18n.t('statesSelect.statesList.AU.NSW'),
        NT: this.i18n.t('statesSelect.statesList.AU.NT'),
        QLD: this.i18n.t('statesSelect.statesList.AU.QLD'),
        SA: this.i18n.t('statesSelect.statesList.AU.SA'),
        TAS: this.i18n.t('statesSelect.statesList.AU.TAS'),
        VIC: this.i18n.t('statesSelect.statesList.AU.VIC'),
        WA: this.i18n.t('statesSelect.statesList.AU.WA')
      },
      CA: {
        AB: this.i18n.t('statesSelect.statesList.CA.AB'),
        BC: this.i18n.t('statesSelect.statesList.CA.BC'),
        MB: this.i18n.t('statesSelect.statesList.CA.MB'),
        NB: this.i18n.t('statesSelect.statesList.CA.NB'),
        NL: this.i18n.t('statesSelect.statesList.CA.NL'),
        NS: this.i18n.t('statesSelect.statesList.CA.NS'),
        NT: this.i18n.t('statesSelect.statesList.CA.NT'),
        NU: this.i18n.t('statesSelect.statesList.CA.NU'),
        ON: this.i18n.t('statesSelect.statesList.CA.ON'),
        PE: this.i18n.t('statesSelect.statesList.CA.PE'),
        QC: this.i18n.t('statesSelect.statesList.CA.QC'),
        SK: this.i18n.t('statesSelect.statesList.CA.SK'),
        YT: this.i18n.t('statesSelect.statesList.CA.YT')
      },
      JP: {
        '01': this.i18n.t('statesSelect.statesList.JP.01'),
        '02': this.i18n.t('statesSelect.statesList.JP.02'),
        '03': this.i18n.t('statesSelect.statesList.JP.03'),
        '04': this.i18n.t('statesSelect.statesList.JP.04'),
        '05': this.i18n.t('statesSelect.statesList.JP.05'),
        '06': this.i18n.t('statesSelect.statesList.JP.06'),
        '07': this.i18n.t('statesSelect.statesList.JP.07'),
        '08': this.i18n.t('statesSelect.statesList.JP.08'),
        '09': this.i18n.t('statesSelect.statesList.JP.09'),
        10: this.i18n.t('statesSelect.statesList.JP.10'),
        11: this.i18n.t('statesSelect.statesList.JP.11'),
        12: this.i18n.t('statesSelect.statesList.JP.12'),
        13: this.i18n.t('statesSelect.statesList.JP.13'),
        14: this.i18n.t('statesSelect.statesList.JP.14'),
        15: this.i18n.t('statesSelect.statesList.JP.15'),
        16: this.i18n.t('statesSelect.statesList.JP.16'),
        17: this.i18n.t('statesSelect.statesList.JP.17'),
        18: this.i18n.t('statesSelect.statesList.JP.18'),
        19: this.i18n.t('statesSelect.statesList.JP.19'),
        20: this.i18n.t('statesSelect.statesList.JP.20'),
        21: this.i18n.t('statesSelect.statesList.JP.21'),
        22: this.i18n.t('statesSelect.statesList.JP.22'),
        23: this.i18n.t('statesSelect.statesList.JP.23'),
        24: this.i18n.t('statesSelect.statesList.JP.24'),
        25: this.i18n.t('statesSelect.statesList.JP.25'),
        26: this.i18n.t('statesSelect.statesList.JP.26'),
        27: this.i18n.t('statesSelect.statesList.JP.27'),
        28: this.i18n.t('statesSelect.statesList.JP.28'),
        29: this.i18n.t('statesSelect.statesList.JP.29'),
        30: this.i18n.t('statesSelect.statesList.JP.30'),
        31: this.i18n.t('statesSelect.statesList.JP.31'),
        32: this.i18n.t('statesSelect.statesList.JP.32'),
        33: this.i18n.t('statesSelect.statesList.JP.33'),
        34: this.i18n.t('statesSelect.statesList.JP.34'),
        35: this.i18n.t('statesSelect.statesList.JP.35'),
        36: this.i18n.t('statesSelect.statesList.JP.36'),
        37: this.i18n.t('statesSelect.statesList.JP.37'),
        38: this.i18n.t('statesSelect.statesList.JP.38'),
        39: this.i18n.t('statesSelect.statesList.JP.39'),
        40: this.i18n.t('statesSelect.statesList.JP.40'),
        41: this.i18n.t('statesSelect.statesList.JP.41'),
        42: this.i18n.t('statesSelect.statesList.JP.42'),
        43: this.i18n.t('statesSelect.statesList.JP.43'),
        44: this.i18n.t('statesSelect.statesList.JP.44'),
        45: this.i18n.t('statesSelect.statesList.JP.45'),
        46: this.i18n.t('statesSelect.statesList.JP.46'),
        47: this.i18n.t('statesSelect.statesList.JP.47')
      },
      US: {
        AK: this.i18n.t('statesSelect.statesList.US.AK'),
        AL: this.i18n.t('statesSelect.statesList.US.AL'),
        AR: this.i18n.t('statesSelect.statesList.US.AR'),
        AZ: this.i18n.t('statesSelect.statesList.US.AZ'),
        CA: this.i18n.t('statesSelect.statesList.US.CA'),
        CO: this.i18n.t('statesSelect.statesList.US.CO'),
        CT: this.i18n.t('statesSelect.statesList.US.CT'),
        DC: this.i18n.t('statesSelect.statesList.US.DC'),
        DE: this.i18n.t('statesSelect.statesList.US.DE'),
        FL: this.i18n.t('statesSelect.statesList.US.FL'),
        GA: this.i18n.t('statesSelect.statesList.US.GA'),
        HI: this.i18n.t('statesSelect.statesList.US.HI'),
        IA: this.i18n.t('statesSelect.statesList.US.IA'),
        ID: this.i18n.t('statesSelect.statesList.US.ID'),
        IL: this.i18n.t('statesSelect.statesList.US.IL'),
        IN: this.i18n.t('statesSelect.statesList.US.IN'),
        KS: this.i18n.t('statesSelect.statesList.US.KS'),
        KY: this.i18n.t('statesSelect.statesList.US.KY'),
        LA: this.i18n.t('statesSelect.statesList.US.LA'),
        MA: this.i18n.t('statesSelect.statesList.US.MA'),
        MD: this.i18n.t('statesSelect.statesList.US.MD'),
        ME: this.i18n.t('statesSelect.statesList.US.ME'),
        MI: this.i18n.t('statesSelect.statesList.US.MI'),
        MN: this.i18n.t('statesSelect.statesList.US.MN'),
        MO: this.i18n.t('statesSelect.statesList.US.MO'),
        MS: this.i18n.t('statesSelect.statesList.US.MS'),
        MT: this.i18n.t('statesSelect.statesList.US.MT'),
        NC: this.i18n.t('statesSelect.statesList.US.NC'),
        ND: this.i18n.t('statesSelect.statesList.US.ND'),
        NE: this.i18n.t('statesSelect.statesList.US.NE'),
        NH: this.i18n.t('statesSelect.statesList.US.NH'),
        NJ: this.i18n.t('statesSelect.statesList.US.NJ'),
        NM: this.i18n.t('statesSelect.statesList.US.NM'),
        NV: this.i18n.t('statesSelect.statesList.US.NV'),
        NY: this.i18n.t('statesSelect.statesList.US.NY'),
        OH: this.i18n.t('statesSelect.statesList.US.OH'),
        OK: this.i18n.t('statesSelect.statesList.US.OK'),
        OR: this.i18n.t('statesSelect.statesList.US.OR'),
        PA: this.i18n.t('statesSelect.statesList.US.PA'),
        RI: this.i18n.t('statesSelect.statesList.US.RI'),
        SC: this.i18n.t('statesSelect.statesList.US.SC'),
        SD: this.i18n.t('statesSelect.statesList.US.SD'),
        TN: this.i18n.t('statesSelect.statesList.US.TN'),
        TX: this.i18n.t('statesSelect.statesList.US.TX'),
        UT: this.i18n.t('statesSelect.statesList.US.UT'),
        VA: this.i18n.t('statesSelect.statesList.US.VA'),
        VT: this.i18n.t('statesSelect.statesList.US.VT'),
        WA: this.i18n.t('statesSelect.statesList.US.WA'),
        WI: this.i18n.t('statesSelect.statesList.US.WI'),
        WV: this.i18n.t('statesSelect.statesList.US.WV'),
        WY: this.i18n.t('statesSelect.statesList.US.WY')
      }
    };
  }
  isoCountryCodeForCountryCode(countryCode) {
    return Object.keys(Country).find(key => Country[key] === countryCode);
  }
  countryNameForCode(countryCode) {
    return this.countryNamesByCode[countryCode];
  }
  stateNamesByCodeForCountryCode(countryCode) {
    return this.stateNamesByCode[countryCode];
  }
  stateNameForCodes(countryCode, stateCode) {
    return this.stateNamesByCode[countryCode][stateCode];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "countryNamesByCode", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "countryNamesByCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stateNamesByCode", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "stateNamesByCode"), _class.prototype), _class);
export { CountriesService as default };